import { Box, Tabs, Tab } from '@mui/material'
import { useMemo, useState } from 'react'
import { PartyBusiness } from './partyBusiness'
import { BranchBusiness } from './branchBusiness'
import { OverallBusiness } from './overAllBusiness'
import UserwiseBusiness from './userwiseBusiness'
import { useTranslation } from '../../../i18n/I18nProvider'

export const headColor = {
  header: '#bfe1ff',
  header2: '#e5f3ff',
  subHeader: '#daedfe',
  total: '#eeeeee',
  entry: '#ffffff',
}
export const BusinessAnalysis = () => {
  const { translations } = useTranslation()
  const db = translations?.dashboard || {}
  const TabList = useMemo(
    () => [
      { id: 1, name: db.partyBusiness || 'Party Business' },
      { id: 2, name: db.branchBusiness || 'Branch Business' },
      { id: 3, name: db.userwiseBusiness || 'Userwise Business' },
      { id: 4, name: db.overallBooking || 'Overall Booking' },
    ],
    [db]
  )

  const [selectedTab, setSelectedTab] = useState(1)

  return (
    <Box>
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" aria-label="bsic tabs example">
        {TabList.map((tab) => (
          <Tab
            key={`tabbusiness_${tab.id}`}
            value={tab.id}
            label={tab.name}
            sx={{
              fontSize: '1rem',
              height: '40px',
              minHeight: '40px',
              fontSize: '12px',
              fontWeight: '600',
            }}
          />
        ))}
      </Tabs>
      {selectedTab === 1 && <PartyBusiness />}
      {selectedTab === 2 && <BranchBusiness />}
      {selectedTab === 3 && <UserwiseBusiness />}
      {selectedTab === 4 && <OverallBusiness />}
    </Box>
  )
}
